import { useQuery } from '@tanstack/react-query';
import { promptRecordsKeys } from './promptRecords.keys';
import { getMessageRecordsById } from './promptRecords.api';
export const useMessageRecordsByIdQuery = (messageId) => {
    return useQuery({
        queryKey: promptRecordsKeys.messageRecordsById(messageId),
        queryFn: () => getMessageRecordsById(messageId),
        staleTime: 5000
    });
};
//# sourceMappingURL=promptRecords.query.js.map